import { useEffect, useRef,useState} from "react";
import {
    getToken,
    getUserId,
    setInizio,
    setFine,
    getInizio,
    getFine,
} from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/analisi.css"
import "../stili/agenda.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdInventario,convertiValuta,convertiTipoRiparazione,convertiIdEscursione,convertiTipoStorage,convertiIdNoleggio,ordinaPerData,prendiNomePacchetto,coloreDaId,guadagnoEscursione,pacchettiAperti,materialeDisponibile,istruttori_disponibili,isoToString,calcolaStipendioFisso,convertiCambi} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX, faPencil, faTrashCan,faCircleInfo,faSpinner,faChartSimple } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
/* global $ */
function AnalisiEconomica() {
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function handleClick(cellInfoGen,periodo,utenti,datiCambi) {
    const content=mostraDettagliPeriodo(cellInfoGen,periodo,utenti,datiCambi)
    $("#infoDettagli").dxPopup("instance").option("contentTemplate", () => content);
    $("#infoDettagli").dxPopup("instance").show();
}
function mostraDettagliPeriodo(cellInfoGen,periodo,utenti,datiCambi){
    let chiave=""
    const data=DateTime.fromJSDate(cellInfoGen.data.data, { zone: 'utc' })
    const chiaveMese=data.toFormat("yyyy-MM")
    const chiaveGiorno=data.toISODate()
    const chiaveSettimana=`${data.weekYear}-W${String(data.weekNumber).padStart(2, "0")}`
    if ($('#divisioneDati').dxTabs("instance").option("selectedIndex")===0){
        chiave=chiaveMese
    }
    else if ($('#divisioneDati').dxTabs("instance").option("selectedIndex")===1)
    chiave=chiaveSettimana
    else chiave=chiaveGiorno
    const periodoInteressato=periodo[chiave]
    let formattedRowsLezione=[]
    let formattedRowsStorage=[]
    let formattedRowsNoleggi=[]
    const divGen=document.createElement("div")
    const titoloEntrate=document.createElement("h1")
    titoloEntrate.innerText="Suddivisione entrate"
    if (periodoInteressato["entrate"])divGen.appendChild(titoloEntrate)
    const divLezioni=document.createElement("div")
    const divNoleggi=document.createElement("div")
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["lezioni"]) divGen.appendChild(divLezioni)
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["noleggi"]) divGen.appendChild(divNoleggi)
    const titoloLezioni=document.createElement("h2")
    titoloLezioni.innerText="Dettagli Lezioni"
    const titoloNoleggi=document.createElement("h2")
    titoloNoleggi.innerText="Dettagli Noleggi"
    const divTabellaLez=document.createElement("div")
    const divTabellaNol=document.createElement("div")
    divLezioni.appendChild(titoloLezioni)
    divTabellaLez.id="datagridDettagliLezioni"
    divTabellaLez.style.maxHeight = "500px"
    divNoleggi.appendChild(titoloNoleggi)
    divNoleggi.appendChild(divTabellaNol)
    divTabellaNol.id="datagridDettagliNoleggi"
    divTabellaNol.style.maxHeight = "500px"
    divLezioni.appendChild(divTabellaLez)


    const divStorage=document.createElement("div")
    const divEscursioni=document.createElement("div")
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["storage"]) divGen.appendChild(divStorage)
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["escursioni"]) divGen.appendChild(divEscursioni)
    const titoloStorage=document.createElement("h2")
    titoloStorage.innerText="Dettagli Storage"
    const titoloEscursioni=document.createElement("h2")
    titoloEscursioni.innerText="Dettagli Escursioni"
    const divTabellaStor=document.createElement("div")
    const divTabellaEsc=document.createElement("div")
    divStorage.appendChild(titoloStorage)
    divTabellaStor.id="datagridDettagliStorage"
    divTabellaStor.style.maxHeight = "500px"
    divEscursioni.appendChild(titoloEscursioni)
    divEscursioni.appendChild(divTabellaEsc)
    divTabellaEsc.id="datagridDettagliEscursioni"
    divTabellaEsc.style.maxHeight = "500px"
    divStorage.appendChild(divTabellaStor)
    const titoloStipendi=document.createElement("h1")
    titoloStipendi.innerText="Divisione stipendi"
    divGen.appendChild(titoloStipendi)

    const divStipLez=document.createElement("div")
    const divStipFis=document.createElement("div")
    const divStipEsc=document.createElement("div")
    if (periodoInteressato["stipendi"]&&periodoInteressato["stipendi"]["lezioni"]) divGen.appendChild(divStipLez)
    if (periodoInteressato["stipendi"]&&periodoInteressato["stipendi"]["fisso"]) divGen.appendChild(divStipFis)
    if (periodoInteressato["stipendi"]&&periodoInteressato["stipendi"]["escursioni"]) divGen.appendChild(divStipEsc)
    const titoloStipLezioni=document.createElement("h2")
    titoloStipLezioni.innerText="Dettagli Commissioni istruttori"
    const titoloStipFissi=document.createElement("h2")
    titoloStipFissi.innerText="Dettagli stipendi fissi"
    const titoloStipEsc=document.createElement("h2")
    titoloStipEsc.innerText="Dettagli commissioni escursioni"
    const divTabellaStipLez=document.createElement("div")
    const divTabellaStipFis=document.createElement("div")
    const divTabellaStipEsc=document.createElement("div")
    divStipLez.appendChild(titoloStipLezioni)
    divStipLez.appendChild(divTabellaStipLez)
    divTabellaStipLez.id="datagridDettagliStipendiLezioni"
    divTabellaStipLez.style.maxHeight = "500px"
    divStipFis.appendChild(titoloStipFissi)
    divStipFis.appendChild(divTabellaStipFis)
    divTabellaStipFis.id="datagridDettagliStipendiFissi"
    divTabellaStipFis.style.maxHeight = "500px"
    divStipEsc.appendChild(titoloStipEsc)
    divStipEsc.appendChild(divTabellaStipEsc)
    divTabellaStipEsc.id="datagridDettagliStipendiEscursioni"
    divTabellaStipEsc.style.maxHeight = "500px"
    const divSpese=document.createElement("div")
    if (periodoInteressato["spese"]) divGen.appendChild(divSpese)
    const titoloSpese=document.createElement("h1")
    titoloSpese.innerText="Suddivisione spese"
    divSpese.appendChild(titoloSpese)
    const divTabellaSpese=document.createElement("div")
    divSpese.appendChild(divTabellaSpese)
    divTabellaSpese.id="datagridDettagliSpese"
    divTabellaSpese.style.maxHeight = "500px"
    if  (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["lezioni"]){
         formattedRowsLezione=periodoInteressato["entrate"]["lezioni"].map((row, index) => ({
            id: index,
            data: convertDate(row.lessonregdate).toISO({ includeOffset: false }),
            nome: row.lessonstudentname,
            pacchetto: row.lessonpacket,
            costo: row.lessoncost*(1-(row.lessondiscount/100)),
          }));
    }
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["noleggi"]){
         formattedRowsNoleggi=periodoInteressato["entrate"]["noleggi"].map((row, index) => ({
            id: index,
            data: convertDate(row.rentalregdate).toISO({ includeOffset: false }),
            nome: row.rentalcustname,
            tipo: convertiIdNoleggio(row.rentaltype),
            costo: row.rentalcost*(1-(row.rentaldiscount/100)),
          }));
    }
    let formattedRowsEscursioni=[]
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["escursioni"]){
        for (let dato of periodoInteressato["entrate"]["escursioni"]){

            formattedRowsEscursioni=[...formattedRowsEscursioni,{data:convertDate(dato[0].excursiondatestart.slice(0,8)).toISO({ includeOffset: false }),
            tipo:convertiIdEscursione(dato[0].excursiontype),
            destinazione:dato[0].excursiondescr,
            guadagno:dato[1]}]
        }
    }
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["storage"]){
         formattedRowsStorage=periodoInteressato["entrate"]["storage"].map((row, index) => ({
            id: index,
            data: convertDate(row.storagefrom).toISO({ includeOffset: false }),
            nome: row.storagecustname,
            tipo: convertiTipoStorage(row.storagetype),
            costo: row.storagecost*(1-(row.storagediscount/100)),
          }));
    }
    let formattedRowsStipendiLezioni=[]
    if (periodoInteressato["stipendi"]&&periodoInteressato["stipendi"]["lezioni"]){
        for (let dato of periodoInteressato["stipendi"]["lezioni"]){
            const durata=(convertDate(dato[0].lessondateend)-convertDate(dato[0].lessondatestart))/(3600*1000)
            const numero = dato[1].lessonnumstudents
            let paga = numero===1?durata*(dato[2].workperiodhourlypayment):durata*(dato[2].workperiodhourlypaymentgroups)
            let tipo=-1
            for (let uten of utenti){
                if (uten.userid===dato[2].userid){
                     tipo=uten.type
                }
            }
            if (tipo===5 && dato[1].lessontype==="Avanzata"){
                let commissionLez=0
                if (dato[0].inventories.length>0)
                    commissionLez=dato[2].workperiodcommissionratelessonmaterial/100
                else
                    commissionLez=dato[2].workperiodcommissionratelesson/100
                paga=((dato[1].lessoncost * (1 - (dato[1].lessondiscount ) / 100))*commissionLez*durata)/dato[1].lessonpacket
            }
            let guadagno=0
            let totOre=dato[1].lessonpacket
            if (dato[1].lessonpacket<dato[1].oretotali) totOre=dato[1].oretotali
            if (dato[2].workperiodfixedsalarycurrency===1)
            guadagno=(((dato[1].lessoncost * (1 - (dato[1].lessondiscount ) / 100)) / totOre) * durata) - paga
            else
             guadagno=(((dato[1].lessoncost * (1 - (dato[1].lessondiscount ) / 100)) / totOre) * durata) - (paga/datiCambi[convertDate(dato[0].lessondatestart).toFormat("yyyyMMdd")])

            formattedRowsStipendiLezioni=[...formattedRowsStipendiLezioni,{
                data:convertDate(dato[0].lessondatestart.slice(0,8)).toISO({ includeOffset: false }),
                "istruttore":nome_id({id:parseInt(dato[0].userid),utenti:utenti}),
                "studente":dato[1].lessonstudentname,
                "durata": differenzaOrario({dataInizio:durata*3600*1000}),
                "stipendio":`${(paga).toLocaleString("it-IT", { maximumFractionDigits: 2 })}${dato[2].workperiodfixedsalarycurrency?convertiValuta(dato[2].workperiodfixedsalarycurrency):''}`,
                "guadagno": `${(guadagno).toLocaleString("it-IT", { maximumFractionDigits: 2 })}€`
            }]
        }
    }
    let formattedRowsStipendiFissi=[]
    if (periodoInteressato["stipendi"]&&periodoInteressato["stipendi"]["fisso"]){
        for (let persona in periodoInteressato["stipendi"]["fisso"]){
        if (periodoInteressato["stipendi"]["fisso"][persona]!==0)
            formattedRowsStipendiFissi=[...formattedRowsStipendiFissi,{
                "persona":nome_id({id:parseInt(persona),utenti:utenti}),
                "stipendio": periodoInteressato["stipendi"]["fisso"][persona],
            }]
        }
    }
    let formattedRowsStipendiEsc=[]
    if (periodoInteressato["stipendi"]&&periodoInteressato["stipendi"]["escursioni"]){
        for (let persona in periodoInteressato["stipendi"]["escursioni"]){
            for (let escursione of periodoInteressato["stipendi"]["escursioni"][persona])
            formattedRowsStipendiEsc=[...formattedRowsStipendiEsc,{
                "persona":nome_id({id:parseInt(persona),utenti:utenti}),
                "data":convertDate(escursione[0].excursiondatestart.slice(0,8)).toISO({ includeOffset: false }),
                tipo:convertiIdEscursione(escursione[0].excursiontype),
                destinazione:escursione[0].excursiondescr,
                "commissione": escursione[2]*(1-(escursione[1].workperiodcommissionrate/100)),
            }]
        }
    }
    let formattedRowsSpese=[]
    if (periodoInteressato["spese"]){
        for (let spesa of periodoInteressato["spese"]){
            formattedRowsSpese=[...formattedRowsSpese,{
                "data":convertDate(spesa.transactiondate.slice(0,8)).toISO({ includeOffset: false }),
                categoria:spesa.registrytypedescr,
                sottocategoria:spesa.registrysubtypedescr,
                "note": spesa.transactionnotes,
                importo:`${spesa.transactionvalue.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`
            }]
        }
    }
    const allineamento="center"
    setTimeout(()=>{
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["lezioni"]){
        $("#datagridDettagliLezioni").dxDataGrid({
            dataSource:formattedRowsLezione,
            columns:[{dataField:"data",caption:"Data vendita",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"nome",caption:"Nome studente",alignment:allineamento,},
            {dataField:"pacchetto",caption:"Pacchetto lezione",alignment:allineamento,customizeText:function(e){return `${e.value}H`}},
            {dataField:"costo",caption:"Costo pacchetto",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["noleggi"]){
        $("#datagridDettagliNoleggi").dxDataGrid({
            dataSource:formattedRowsNoleggi,
            columns:[{dataField:"data",caption:"Data vendita",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"nome",caption:"Nome cliente",alignment:allineamento,},
            {dataField:"tipo",caption:"Tipo noleggio",alignment:allineamento},
            {dataField:"costo",caption:"Costo noleggio",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["storage"]){
        $("#datagridDettagliStorage").dxDataGrid({
            dataSource:formattedRowsStorage,
            columns:[{dataField:"data",caption:"Data vendita",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"nome",caption:"Nome cliente",alignment:allineamento,},
            {dataField:"tipo",caption:"Tipo storage",alignment:allineamento},
            {dataField:"costo",caption:"Costo storage",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["escursioni"]){
        $("#datagridDettagliEscursioni").dxDataGrid({
            dataSource:formattedRowsEscursioni,
            columns:[{dataField:"data",caption:"Data escursione",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"tipo",caption:"Tipo escursione",alignment:allineamento},
            {dataField:"destinazione",caption:"Destinazione escursione",alignment:allineamento,},
            {dataField:"guadagno",caption:"Guadagno escursione",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    if (periodoInteressato["stipendi"]&&periodoInteressato["stipendi"]["lezioni"]){
        $("#datagridDettagliStipendiLezioni").dxDataGrid({
            dataSource:formattedRowsStipendiLezioni,
            columns:[{dataField:"data",caption:"Data lezione",alignment:allineamento, hidingPriority:1,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"istruttore",caption:"Istruttore",alignment:allineamento, hidingPriority:3},
            {dataField:"studente",caption:"Nome studente",alignment:allineamento, hidingPriority:2},
            {dataField:"durata",caption:"Durata lezione",alignment:allineamento, hidingPriority:1},
            {dataField:"stipendio",caption:"Commissione lezione",alignment:allineamento, hidingPriority:4},
            {dataField:"guadagno",caption:"Guadagno lezione",alignment:allineamento, hidingPriority:5},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    if (periodoInteressato["stipendi"]&&periodoInteressato["stipendi"]["fisso"]){
        $("#datagridDettagliStipendiFissi").dxDataGrid({
            dataSource:formattedRowsStipendiFissi,
            columns:[
            {dataField:"persona",caption:"Persona",alignment:allineamento},
            {dataField:"stipendio",caption:"Stipendio fisso",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    if (periodoInteressato["stipendi"]&&periodoInteressato["stipendi"]["escursioni"]){
        $("#datagridDettagliStipendiEscursioni").dxDataGrid({
            dataSource:formattedRowsStipendiEsc,
            columns:[
            {dataField:"persona",caption:"Persona",alignment:allineamento},
            {dataField:"data",caption:"Data vendita",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"tipo",caption:"Tipo escursione",alignment:allineamento},
            {dataField:"destinazione",caption:"Destinazione escursione",alignment:allineamento,},
            {dataField:"commissione",caption:"Commissione",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    if (periodoInteressato["spese"]){
        $("#datagridDettagliSpese").dxDataGrid({
            dataSource:formattedRowsSpese,
            columns:[
            {dataField:"data",caption:"Data Spesa",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"categoria",caption:"Categoria Spesa",alignment:allineamento},
            {dataField:"sottocategoria",caption:"Sottocategoria Spesa",alignment:allineamento,},
            {dataField:"note",caption:"Note Spesa",alignment:allineamento,},
            {dataField:"importo",caption:"Importo spesa",alignment:allineamento,},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    },0)
    return divGen
}
    function apriPopupDettagliSpesa(evento, listaCosti,listaNumeri) {
  const dettagli = listaCosti[evento.target.argument];
  const dataSourceDettagliSpese = Object.entries(dettagli).map(
    ([category, valore]) => ({ category, valore })
  );
  let dataSourceDettagliSpeseNumeri=[]
  if (listaNumeri){
  const dettagli2 = listaNumeri[evento.target.argument];

   dataSourceDettagliSpeseNumeri = Object.entries(dettagli2).map(
    ([category, valore]) => ({ category, valore })
  );}
$("#infoDettagli").dxPopup("instance").option(
            "title",
            `Dettagli ${evento.target.argument}`
          );
  $("#infoDettagli").dxPopup("instance").option("contentTemplate", () => {
    const divGen = document.createElement("div");
    const divGraf=document.createElement("div");
    const divTab=document.createElement("div");
    divGen.style.height="100%"
    divGen.style.width="100%"
    divGraf.id = "chartPieDettagliSpese";
    divTab.id = "tabsDettagliSpese";
    divGraf.style.height="100%"
    divGraf.style.width="100%"
    if (listaNumeri)
    divGen.appendChild(divTab)
    divGen.appendChild(divGraf)

    const tabsIconAndText=[
      { id: 0, text: 'Rappresentazione costo'},
      { id: 1, text: 'Rappresentazione numero'},
    ];
    setTimeout(() => {

      $("#chartPieDettagliSpese").dxPieChart({
        dataSource: dataSourceDettagliSpese,
        height:"100%",
        width:"100%",
        series: {
          argumentField: "category",
          valueField: "valore",
          label: {
            visible: true,
            connector: { visible: true },
            customizeText: function (pointInfo) {
      return `${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`;
    }
          },
        },
        export: {
          enabled: true,
          formats: ["PNG", "PDF", "JPEG", "SVG"],
          fileName: "grafico",
        },
        tooltip: {
          enabled: true,
          customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>Categoria:</b> ${pointInfo.argument}<br>
            <b>Valore:</b> ${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} € <br>
            <b>Percentuale:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
        },
        legend: {
          horizontalAlignment: "center",
          verticalAlignment: "bottom",
        },
      });
      $('#tabsDettagliSpese').dxTabs({
      width: '100%',
      rtlEnabled: false,
      showNavButtons: false,
      dataSource: tabsIconAndText,
      orientation: "horizontal",
      stylingMode: "primary",
      iconPosition: "top",
      onSelectionChanged: function (e) {let  newIndex = e.component.option("selectedIndex");
        if (newIndex===-1)newIndex=0
        if (newIndex===0)
        $("#chartPieDettagliSpese").dxPieChart("instance").option("dataSource",dataSourceDettagliSpese)
        else
        $("#chartPieDettagliSpese").dxPieChart("instance").option("dataSource",dataSourceDettagliSpeseNumeri)

      }
      })
      if (listaNumeri)
      $('#tabsDettagliSpese').dxTabs("instance").option("selectedIndex", 0)
    }, 0);

    return divGen;
  });

  $("#infoDettagli").dxPopup("instance").show();
}

    function creaKPI(titolo, valore,colore) {
  const box = document.createElement("div");
  box.className = "kpi-box flex-item"; // <-- aggiunto "flex-item"

  const title = document.createElement("div");
  title.className = "kpi-title";
  title.textContent = titolo;

  const val = document.createElement("div");
  val.className = `kpi-value ${colore}`;
  val.textContent = valore;

  box.appendChild(title);
  box.appendChild(val);
  return box;
}

    useEffect(() => {
        let fineModIn1=null
        let fineModIn2=null
        let inizioModIn1=null
        let inizioModIn2=null
        const fetchDati = async () => {
        const datebox=$("#dateboxperiodo").dxDateRangeBox({
            displayFormat: "dd/MM/yyyy",
            startDateLabel: "Inizio periodo",
            endDateLabel: "Fine Periodo",
            showClearButton: true,
            openOnFieldClick: true,
            startDateInputAttr: { readonly: true, onkeydown: "return false", inputmode: 'none' },
            endDateInputAttr:   { readonly: true, onkeydown: "return false", inputmode: 'none' },
            startDate: getInizio() ? new Date(getInizio()) : new Date(2025, 11, 15),
            endDate: getFine() ? new Date(getFine()) : new Date(2026, 3, 1),
            onValueChanged:function(e){
                setInizio(DateTime.fromJSDate(e.value[0]).toISO())
                setFine(DateTime.fromJSDate(e.value[1]).toISO())
            },
            onFocusOut: function(e){
            fineModIn1= $("#dateboxperiodo").dxDateRangeBox("instance").option("startDate")
            fineModIn2= $("#dateboxperiodo").dxDateRangeBox("instance").option("endDate")
            if (inizioModIn1!==fineModIn1 ||inizioModIn2!==fineModIn2){
                window.location.reload()
            }
        },
        onFocusIn: function(e){
            inizioModIn1= $("#dateboxperiodo").dxDateRangeBox("instance").option("startDate")
            inizioModIn2= $("#dateboxperiodo").dxDateRangeBox("instance").option("endDate")
        },
        }).dxDateRangeBox("instance")

        $("#loadingOverlay").show()
        const inizioFiltro=DateTime.fromJSDate($("#dateboxperiodo").dxDateRangeBox("instance").option("startDate")).toFormat("yyyyMMdd")
        const fineFiltro=DateTime.fromJSDate($("#dateboxperiodo").dxDateRangeBox("instance").option("endDate")).toFormat("yyyyMMdd")
        const filtroL=convertDate(inizioFiltro)
        let finePF=convertDate(fineFiltro)
        finePF=finePF.plus({hours:23})
        const datiPacchetti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getLessons",
                })
        const periodi= await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getUserWorkPeriods",
                })
        const datiNoleggi = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getRentals",})
        const datiStorage = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getStorages",})
        const datiMaglie = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getAccessoryItems",})
        const datiLezioni = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getLessonDates",
                filtri:{"lessondatesfrom":inizioFiltro,"lessondatesto":finePF.toFormat("yyyyMMddHHmm")},
                childs:["inventories"]})
        const datiUtenti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getUsers",})
        let datiCambi = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExchanges",
                filtri:{"exchangefrom":inizioFiltro,"exchangeto":(convertDate(fineFiltro).plus({days:1}).toFormat("yyyyMMdd")),"exchangerates":"USDEUR"+","+"USDKES"},
                })
        const spese = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "GetTransactions",})
        const escursioni = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExcursions",})
        const escursioniClienti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExcursionCusts",})
        const stipendiPagati = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getSalaryItems",})
        const escursioniCosti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExcursionCosts",})
        const riparazioni = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getRepairs",})
        datiCambi=convertiCambi(datiCambi,["EURKES"])
        $("#loadingOverlay").hide()
        let entrateTot=0
        let periodiDettagliati={1:{},2:{},3:{}}
        let tipiLezioni={}
        let numeriLezioni={}
        let tipiNoleggi={}
        let numeriNoleggi={}
        let tipiStorage={}
        let tipiMaglie={}
        let numeriMaglie={}
        let tipiRiparazioni={}
        let numeriRiparazioni={}
        let numeriStorage={}
        let tipiEscursioni={}
        let numeriEscursioni={}
        let entratePeriodi={1:{},2:{},3:{}}
        let stipendiPeriodi={1:{},2:{},3:{}}
        let spesePeriodi={1:{},2:{},3:{}}
        let speseTot=0
        let entrateLezioni=0
        let entrateMaglie=0
        let pagatoMaglie=0
        let pagatoLezioni=0
        let entrateNoleggi=0
        let pagatoNoleggi=0
        let entrateStorage=0
        let pagatoStorage=0
        let entrateEscursioni=0
        let speseEscursioni=0
        let pagatoEscursioni=0
        let stipendiPersonale={}
        let stipendiFissi=0
        let entratelezC=0
        let entrateRiparazioni=0
        let soldiFuori={lezioni:[],noleggi:[],storage:[],escursioni:{},maglie:[],riparazioni:[]}
        for (let lezione of datiPacchetti){
            let lezioniSpecifiche=[]
            for (let lezioneD of datiLezioni){
                if (lezioneD.lessonid===lezione.lessonid&& lezioneD.lessondatestatus==2){
                    lezioniSpecifiche.push(lezioneD)
                }
            }
            let oreCompletate=0
            let cifraRaggiunta=0
            let pacchettoLez=lezione.lessonpacket
            for (let lezioneD of lezioniSpecifiche){
                oreCompletate+=((convertDate(lezioneD.lessondateend)-convertDate(lezioneD.lessondatestart))/(3600*1000))}
            if (oreCompletate>lezione.lessonpacket) pacchettoLez=oreCompletate
            if (lezioniSpecifiche.length>0){
                    const dataStorage=convertDate(lezione.lessonregdate)
                    if (filtroL<=dataStorage && finePF>=dataStorage){
                        entrateLezioni+=lezione.lessoncost*(1-(lezione.lessondiscount/100))
                        entrateTot+=lezione.lessonadvance
                        const chiaveMese=dataStorage.toFormat("yyyy-MM")
                        const chiaveGiorno=dataStorage.toISODate()
                        const chiaveSettimana=`${dataStorage.weekYear}-W${String(dataStorage.weekNumber).padStart(2, "0")}`

                        if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
                        if (!("entrate" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["entrate"]={}
                        if (!("lezioni" in periodiDettagliati[1][chiaveMese]["entrate"]))periodiDettagliati[1][chiaveMese]["entrate"]["lezioni"]=[]
                        periodiDettagliati[1][chiaveMese]["entrate"]["lezioni"]=[...periodiDettagliati[1][chiaveMese]["entrate"]["lezioni"],lezione]
                        if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
                        if (!("entrate" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["entrate"]={}
                        if (!("lezioni" in periodiDettagliati[3][chiaveGiorno]["entrate"]))periodiDettagliati[3][chiaveGiorno]["entrate"]["lezioni"]=[]
                        periodiDettagliati[3][chiaveGiorno]["entrate"]["lezioni"]=[...periodiDettagliati[3][chiaveGiorno]["entrate"]["lezioni"],lezione]
                        if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                        if (!("entrate" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["entrate"]={}
                        if (!("lezioni" in periodiDettagliati[2][chiaveSettimana]["entrate"]))periodiDettagliati[2][chiaveSettimana]["entrate"]["lezioni"]=[]
                        periodiDettagliati[2][chiaveSettimana]["entrate"]["lezioni"]=[...periodiDettagliati[2][chiaveSettimana]["entrate"]["lezioni"],lezione]
                        if (Math.abs(lezione.lessonadvance - lezione.lessoncost*(1-(lezione.lessondiscount/100))) > 0.01){
                            soldiFuori["lezioni"]=[...soldiFuori["lezioni"],lezione]
                        }
                        if (!(lezione.lessontype in tipiLezioni))tipiLezioni[lezione.lessontype]=0
                        tipiLezioni[lezione.lessontype]+=lezione.lessoncost*(1-(lezione.lessondiscount/100))
                        if (!(lezione.lessontype in numeriLezioni)) numeriLezioni[lezione.lessontype]=0
                        numeriLezioni[lezione.lessontype]+=1
                }
                for (let lezioneD of lezioniSpecifiche){
                    const dataStorage=convertDate(lezioneD.lessondatestart)
                    if (filtroL<=dataStorage && finePF>=dataStorage){
                        const chiaveMese=dataStorage.toFormat("yyyy-MM")
                        const chiaveGiorno=dataStorage.toISODate()
                        const chiaveSettimana=`${dataStorage.weekYear}-W${String(dataStorage.weekNumber).padStart(2, "0")}`
                        const durataL=((convertDate(lezioneD.lessondateend)-convertDate(lezioneD.lessondatestart))/(3600*1000))
                        const guadLez=((lezione.lessoncost*(1-(lezione.lessondiscount/100)))/(pacchettoLez))*durataL
                        cifraRaggiunta+=guadLez
                        if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                        entratePeriodi[1][chiaveMese]+=((lezione.lessoncost*(1-(lezione.lessondiscount/100)))/(pacchettoLez))*durataL
                        if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                        entratePeriodi[3][chiaveGiorno]+=((lezione.lessoncost*(1-(lezione.lessondiscount/100)))/(pacchettoLez))*durataL
                        if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                        entratePeriodi[2][chiaveSettimana]+=((lezione.lessoncost*(1-(lezione.lessondiscount/100)))/(pacchettoLez))*durataL
                        entratelezC+=((lezione.lessoncost*(1-(lezione.lessondiscount/100)))/(pacchettoLez))*durataL
                    }
                }
            }
            if (lezioniSpecifiche.length===0 || (pacchettoLez-oreCompletate)>0.05) {
                const dataStorage=convertDate(lezione.lessonregdate)
                if (filtroL<=dataStorage && finePF>=dataStorage){
                    const chiaveMese=dataStorage.toFormat("yyyy-MM")
                    const chiaveGiorno=dataStorage.toISODate()
                    const chiaveSettimana=`${dataStorage.weekYear}-W${String(dataStorage.weekNumber).padStart(2, "0")}`
                    if (lezioniSpecifiche.length===0){
                    entrateLezioni+=lezione.lessoncost*(1-(lezione.lessondiscount/100))
                    entrateTot+=lezione.lessonadvance
                    entratelezC+=lezione.lessoncost*(1-(lezione.lessondiscount/100))
                    if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                    entratePeriodi[1][chiaveMese]+=((lezione.lessoncost*(1-(lezione.lessondiscount/100))))
                    if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                    entratePeriodi[3][chiaveGiorno]+=lezione.lessoncost*(1-(lezione.lessondiscount/100))
                    if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                    entratePeriodi[2][chiaveSettimana]+=lezione.lessoncost*(1-(lezione.lessondiscount/100))
                    if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
                   if (!("entrate" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["entrate"]={}
                   if (!("lezioni" in periodiDettagliati[1][chiaveMese]["entrate"]))periodiDettagliati[1][chiaveMese]["entrate"]["lezioni"]=[]
                    periodiDettagliati[1][chiaveMese]["entrate"]["lezioni"]=[...periodiDettagliati[1][chiaveMese]["entrate"]["lezioni"],lezione]
                    if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
                   if (!("entrate" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["entrate"]={}
                   if (!("lezioni" in periodiDettagliati[3][chiaveGiorno]["entrate"]))periodiDettagliati[3][chiaveGiorno]["entrate"]["lezioni"]=[]
                    periodiDettagliati[3][chiaveGiorno]["entrate"]["lezioni"]=[...periodiDettagliati[3][chiaveGiorno]["entrate"]["lezioni"],lezione]
                    if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                    if (!("entrate" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["entrate"]={}
                    if (!("lezioni" in periodiDettagliati[2][chiaveSettimana]["entrate"]))periodiDettagliati[2][chiaveSettimana]["entrate"]["lezioni"]=[]
                    periodiDettagliati[2][chiaveSettimana]["entrate"]["lezioni"]=[...periodiDettagliati[2][chiaveSettimana]["entrate"]["lezioni"],lezione]
                    if (Math.abs(lezione.lessonadvance - lezione.lessoncost*(1-(lezione.lessondiscount/100))) > 0.01){
                        soldiFuori["lezioni"]=[...soldiFuori["lezioni"],lezione]
                    }
                    if (!(lezione.lessontype in tipiLezioni))tipiLezioni[lezione.lessontype]=0
                    tipiLezioni[lezione.lessontype]+=lezione.lessoncost*(1-(lezione.lessondiscount/100))
                    if (!(lezione.lessontype in numeriLezioni)) numeriLezioni[lezione.lessontype]=0
                    numeriLezioni[lezione.lessontype]+=1}
                    else{
                    entratelezC+=((lezione.lessoncost*(1-(lezione.lessondiscount/100))))-cifraRaggiunta
                        if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                        entratePeriodi[1][chiaveMese]+=((lezione.lessoncost*(1-(lezione.lessondiscount/100))))-cifraRaggiunta
                        if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                        entratePeriodi[3][chiaveGiorno]+=lezione.lessoncost*(1-(lezione.lessondiscount/100))-cifraRaggiunta
                        if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                        entratePeriodi[2][chiaveSettimana]+=lezione.lessoncost*(1-(lezione.lessondiscount/100))-cifraRaggiunta
                    }
                }
            }
        }
        for (let noleggio of datiNoleggi){
           const dataStorage=convertDate(noleggio.rentalregdate)
           if (filtroL<=dataStorage && finePF>=dataStorage){
               entrateNoleggi+=noleggio.rentalcost*(1-(noleggio.rentaldiscount/100))
               entrateTot+=noleggio.rentaladvance
               const chiaveMese=dataStorage.toFormat("yyyy-MM")
                const chiaveGiorno=dataStorage.toISODate()
                const chiaveSettimana=`${dataStorage.weekYear}-W${String(dataStorage.weekNumber).padStart(2, "0")}`
               if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                entratePeriodi[1][chiaveMese]+=noleggio.rentalcost*(1-(noleggio.rentaldiscount/100))
                if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                entratePeriodi[3][chiaveGiorno]+=noleggio.rentalcost*(1-(noleggio.rentaldiscount/100))
                if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                entratePeriodi[2][chiaveSettimana]+=noleggio.rentalcost*(1-(noleggio.rentaldiscount/100))
               if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
               if (!("entrate" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["entrate"]={}
               if (!("noleggi" in periodiDettagliati[1][chiaveMese]["entrate"]))periodiDettagliati[1][chiaveMese]["entrate"]["noleggi"]=[]
                periodiDettagliati[1][chiaveMese]["entrate"]["noleggi"]=[...periodiDettagliati[1][chiaveMese]["entrate"]["noleggi"],noleggio]
                if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
               if (!("entrate" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["entrate"]={}
               if (!("noleggi" in periodiDettagliati[3][chiaveGiorno]["entrate"]))periodiDettagliati[3][chiaveGiorno]["entrate"]["noleggi"]=[]
                periodiDettagliati[3][chiaveGiorno]["entrate"]["noleggi"]=[...periodiDettagliati[3][chiaveGiorno]["entrate"]["noleggi"],noleggio]
                if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                if (!("entrate" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["entrate"]={}
                if (!("noleggi" in periodiDettagliati[2][chiaveSettimana]["entrate"]))periodiDettagliati[2][chiaveSettimana]["entrate"]["noleggi"]=[]
                periodiDettagliati[2][chiaveSettimana]["entrate"]["noleggi"]=[...periodiDettagliati[2][chiaveSettimana]["entrate"]["noleggi"],noleggio]
               if (Math.abs(noleggio.rentaladvance - noleggio.rentalcost*(1-(noleggio.rentaldiscount/100))) > 0.01){
                    soldiFuori["noleggi"]=[...soldiFuori["noleggi"],noleggio]
               }
               if (!(convertiIdNoleggio(noleggio.rentaltype) in tipiNoleggi))tipiNoleggi[convertiIdNoleggio(noleggio.rentaltype)]=0
                tipiNoleggi[convertiIdNoleggio(noleggio.rentaltype)]+=noleggio.rentalcost*(1-(noleggio.rentaldiscount/100))
                if (!(convertiIdNoleggio(noleggio.rentaltype) in numeriNoleggi)) numeriNoleggi[convertiIdNoleggio(noleggio.rentaltype)]=0
                numeriNoleggi[convertiIdNoleggio(noleggio.rentaltype)]+=1
           }
        }
        for (let storage of datiStorage){
            const dataStorage=convertDate(storage.storagefrom)
            if (filtroL<=dataStorage && finePF>=dataStorage){
               entrateStorage+=storage.storagecost*(1-(storage.storagediscount/100))
               entrateTot+=storage.storageadvance
               const chiaveMese=dataStorage.toFormat("yyyy-MM")
                const chiaveGiorno=dataStorage.toISODate()
                const chiaveSettimana=`${dataStorage.weekYear}-W${String(dataStorage.weekNumber).padStart(2, "0")}`
               if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                entratePeriodi[1][chiaveMese]+=storage.storagecost*(1-(storage.storagediscount/100))
                if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                entratePeriodi[3][chiaveGiorno]+=storage.storagecost*(1-(storage.storagediscount/100))
                if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                entratePeriodi[2][chiaveSettimana]+=storage.storagecost*(1-(storage.storagediscount/100))
               if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
               if (!("entrate" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["entrate"]={}
               if (!("storage" in periodiDettagliati[1][chiaveMese]["entrate"]))periodiDettagliati[1][chiaveMese]["entrate"]["storage"]=[]
                periodiDettagliati[1][chiaveMese]["entrate"]["storage"]=[...periodiDettagliati[1][chiaveMese]["entrate"]["storage"],storage]
                if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
               if (!("entrate" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["entrate"]={}
               if (!("storage" in periodiDettagliati[3][chiaveGiorno]["entrate"]))periodiDettagliati[3][chiaveGiorno]["entrate"]["storage"]=[]
                periodiDettagliati[3][chiaveGiorno]["entrate"]["storage"]=[...periodiDettagliati[3][chiaveGiorno]["entrate"]["storage"],storage]
                if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                if (!("entrate" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["entrate"]={}
                if (!("storage" in periodiDettagliati[2][chiaveSettimana]["entrate"]))periodiDettagliati[2][chiaveSettimana]["entrate"]["storage"]=[]
                periodiDettagliati[2][chiaveSettimana]["entrate"]["storage"]=[...periodiDettagliati[2][chiaveSettimana]["entrate"]["storage"],storage]
               if (Math.abs(storage.storageadvance - storage.storagecost*(1-(storage.storagediscount/100))) > 0.01){
                    soldiFuori["storage"]=[...soldiFuori["storage"],storage]
               }
               if (!(convertiTipoStorage(storage.storagetype) in tipiStorage))tipiStorage[convertiTipoStorage(storage.storagetype)]=0
                tipiStorage[convertiTipoStorage(storage.storagetype)]+=storage.storagecost*(1-(storage.storagediscount/100))
                if (!(convertiTipoStorage(storage.storagetype) in numeriStorage)) numeriStorage[convertiTipoStorage(storage.storagetype)]=0
                numeriStorage[convertiTipoStorage(storage.storagetype)]+=1
            }
        }
        for (let maglia of datiMaglie){
            if (maglia.accessorysoldprice && maglia.accessorysoldprice!==0){
                const dataStorage=convertDate(maglia.accessorysolddate)
                if (filtroL<=dataStorage && finePF>=dataStorage){
                    const entrataMaglia=maglia.accessorysoldcurrency===1?maglia.accessorysoldprice:maglia.accessorysoldprice/datiCambi[maglia.accessorysolddate]
                    const anticipMag=maglia.accessorysoldcurrency===1?maglia.accessorysoldadvance:maglia.accessorysoldadvance/datiCambi[maglia.accessorysolddate]
                   entrateMaglie+=entrataMaglia
                   entrateTot+=anticipMag
                   const chiaveMese=dataStorage.toFormat("yyyy-MM")
                    const chiaveGiorno=dataStorage.toISODate()
                    const chiaveSettimana=`${dataStorage.weekYear}-W${String(dataStorage.weekNumber).padStart(2, "0")}`
                   if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                    entratePeriodi[1][chiaveMese]+=entrataMaglia
                    if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                    entratePeriodi[3][chiaveGiorno]+=entrataMaglia
                    if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                    entratePeriodi[2][chiaveSettimana]+=entrataMaglia
                   if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
                   if (!("entrate" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["entrate"]={}
                   if (!("maglie" in periodiDettagliati[1][chiaveMese]["entrate"]))periodiDettagliati[1][chiaveMese]["entrate"]["maglie"]=[]
                    periodiDettagliati[1][chiaveMese]["entrate"]["maglie"]=[...periodiDettagliati[1][chiaveMese]["entrate"]["maglie"],maglia]
                    if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
                   if (!("entrate" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["entrate"]={}
                   if (!("maglie" in periodiDettagliati[3][chiaveGiorno]["entrate"]))periodiDettagliati[3][chiaveGiorno]["entrate"]["maglie"]=[]
                    periodiDettagliati[3][chiaveGiorno]["entrate"]["maglie"]=[...periodiDettagliati[3][chiaveGiorno]["entrate"]["maglie"],maglia]
                    if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                    if (!("entrate" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["entrate"]={}
                    if (!("maglie" in periodiDettagliati[2][chiaveSettimana]["entrate"]))periodiDettagliati[2][chiaveSettimana]["entrate"]["maglie"]=[]
                    periodiDettagliati[2][chiaveSettimana]["entrate"]["maglie"]=[...periodiDettagliati[2][chiaveSettimana]["entrate"]["maglie"],maglia]
                   if (Math.abs(maglia.accessorysoldadvance - maglia.accessorysoldprice) > 0.01){
                        soldiFuori["maglie"]=[...soldiFuori["maglie"],maglia]
                   }
                   const mappa={1:"Maglietta",2:"Cappello",3:"Laccio per Occhiali"}
                   if (!(mappa[maglia.accessorytype] in tipiMaglie))tipiMaglie[mappa[maglia.accessorytype]]=0
                    tipiMaglie[mappa[maglia.accessorytype]]+=entrataMaglia
                    if (!(mappa[maglia.accessorytype] in numeriMaglie)) numeriMaglie[mappa[maglia.accessorytype]]=0
                    numeriMaglie[mappa[maglia.accessorytype]]+=1
                }
            }
        }
        for (let riparazione of riparazioni){
            const dataStorage=convertDate(riparazione.repairdate)
            if (filtroL<=dataStorage && finePF>=dataStorage){
                const entrataRiparazione=riparazione.repaircostcurrency===1?riparazione.repaircost:riparazione.repaircost/datiCambi[riparazione.repairdate]
                const anticipRip=riparazione.repaircostcurrency===1?riparazione.repairadvance:riparazione.repairadvance/datiCambi[riparazione.repairdate]
               entrateRiparazioni+=entrataRiparazione
               entrateTot+=anticipRip
               const chiaveMese=dataStorage.toFormat("yyyy-MM")
                const chiaveGiorno=dataStorage.toISODate()
                const chiaveSettimana=`${dataStorage.weekYear}-W${String(dataStorage.weekNumber).padStart(2, "0")}`
               if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                entratePeriodi[1][chiaveMese]+=entrataRiparazione
                if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                entratePeriodi[3][chiaveGiorno]+=entrataRiparazione
                if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                entratePeriodi[2][chiaveSettimana]+=entrataRiparazione
               if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
               if (!("entrate" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["entrate"]={}
               if (!("riparazioni" in periodiDettagliati[1][chiaveMese]["entrate"]))periodiDettagliati[1][chiaveMese]["entrate"]["riparazioni"]=[]
                periodiDettagliati[1][chiaveMese]["entrate"]["riparazioni"]=[...periodiDettagliati[1][chiaveMese]["entrate"]["riparazioni"],riparazione]
                if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
               if (!("entrate" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["entrate"]={}
               if (!("riparazioni" in periodiDettagliati[3][chiaveGiorno]["entrate"]))periodiDettagliati[3][chiaveGiorno]["entrate"]["riparazioni"]=[]
                periodiDettagliati[3][chiaveGiorno]["entrate"]["riparazioni"]=[...periodiDettagliati[3][chiaveGiorno]["entrate"]["riparazioni"],riparazione]
                if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                if (!("entrate" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["entrate"]={}
                if (!("riparazioni" in periodiDettagliati[2][chiaveSettimana]["entrate"]))periodiDettagliati[2][chiaveSettimana]["entrate"]["riparazioni"]=[]
                periodiDettagliati[2][chiaveSettimana]["entrate"]["riparazioni"]=[...periodiDettagliati[2][chiaveSettimana]["entrate"]["riparazioni"],riparazione]
               if (Math.abs(riparazione.accessorysoldadvance - riparazione.accessorysoldprice) > 0.01){
                    soldiFuori["riparazioni"]=[...soldiFuori["riparazioni"],riparazione]
               }
               let mappa={}
               let contaRi=1
               while (convertiTipoRiparazione(contaRi)){
                mappa[contaRi]=convertiTipoRiparazione(contaRi)
                contaRi+=1
               }
               if (!(mappa[riparazione.repairtype] in tipiRiparazioni))tipiRiparazioni[mappa[riparazione.repairtype]]=0
                tipiRiparazioni[mappa[riparazione.repairtype]]+=entrataRiparazione
                if (!(mappa[riparazione.repairtype] in numeriRiparazioni)) numeriRiparazioni[mappa[riparazione.repairtype]]=0
                numeriRiparazioni[mappa[riparazione.repairtype]]+=1
            }
        }
        for (let escursione of escursioni){
            const dataEsc=convertDate(escursione.excursiondatestart)
            if (filtroL<=dataEsc && finePF>=dataEsc){
                for (let persona of escursioniClienti){
                    if (persona.excursionid===escursione.excursionid){
                        entrateTot+=persona.excursioncustomeradvance
                        if (Math.abs(persona.excursioncustomeradvance - persona.excursioncustomerpaid) > 0.01){
                            if (!(escursione.excursionid in soldiFuori["escursioni"])) soldiFuori["escursioni"][escursione.excursionid]=[]
                            soldiFuori["escursioni"][escursione.excursionid]=[...soldiFuori["escursioni"][escursione.excursionid],persona]
                        }
                    }
                }
                const guadagniEsc=guadagnoEscursione({escursione:escursione,spese:escursioniCosti,partecipanti:escursioniClienti,cambio:datiCambi})
                entrateEscursioni+=guadagniEsc[0]-guadagniEsc[1]
                speseTot+=guadagniEsc[1]
                if (!(convertiIdEscursione(escursione.excursiontype) in tipiEscursioni))tipiEscursioni[convertiIdEscursione(escursione.excursiontype)]=0
                tipiEscursioni[convertiIdEscursione(escursione.excursiontype)]+=guadagniEsc[0]-guadagniEsc[1]
                if (!(convertiIdEscursione(escursione.excursiontype) in numeriEscursioni)) numeriEscursioni[convertiIdEscursione(escursione.excursiontype)]=0
                numeriEscursioni[convertiIdEscursione(escursione.excursiontype)]+=1
                const chiaveMese=dataEsc.toFormat("yyyy-MM")
                const chiaveGiorno=dataEsc.toISODate()
                const chiaveSettimana=`${dataEsc.weekYear}-W${String(dataEsc.weekNumber).padStart(2, "0")}`
                if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                entratePeriodi[1][chiaveMese]+=guadagniEsc[0]-guadagniEsc[1]
                if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                entratePeriodi[3][chiaveGiorno]+=guadagniEsc[0]-guadagniEsc[1]
                if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                entratePeriodi[2][chiaveSettimana]+=guadagniEsc[0]-guadagniEsc[1]
                speseEscursioni+=guadagniEsc[1]
                if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
               if (!("entrate" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["entrate"]={}
               if (!("escursioni" in periodiDettagliati[1][chiaveMese]["entrate"]))periodiDettagliati[1][chiaveMese]["entrate"]["escursioni"]=[]
                periodiDettagliati[1][chiaveMese]["entrate"]["escursioni"]=[...periodiDettagliati[1][chiaveMese]["entrate"]["escursioni"],[escursione,guadagniEsc[0]-guadagniEsc[1]]]
                if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
               if (!("entrate" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["entrate"]={}
               if (!("escursioni" in periodiDettagliati[3][chiaveGiorno]["entrate"]))periodiDettagliati[3][chiaveGiorno]["entrate"]["escursioni"]=[]
                periodiDettagliati[3][chiaveGiorno]["entrate"]["escursioni"]=[...periodiDettagliati[3][chiaveGiorno]["entrate"]["escursioni"],[escursione,guadagniEsc[0]-guadagniEsc[1]]]
                if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                if (!("entrate" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["entrate"]={}
                if (!("escursioni" in periodiDettagliati[2][chiaveSettimana]["entrate"]))periodiDettagliati[2][chiaveSettimana]["entrate"]["escursioni"]=[]
                periodiDettagliati[2][chiaveSettimana]["entrate"]["escursioni"]=[...periodiDettagliati[2][chiaveSettimana]["entrate"]["escursioni"],[escursione,guadagniEsc[0]-guadagniEsc[1]]]

            }
        }

        for (let lezione of datiLezioni){
            const dataLez=convertDate(lezione.lessondatestart)
            if (lezione.lessondatestatus===2 && (filtroL<=dataLez && finePF>=dataLez)){
                for (let pacchetto of datiPacchetti){
                    if (pacchetto.lessonid===lezione.lessonid){
                        for (let istruttore of datiUtenti){
                            if (istruttore.userid===lezione.userid){
                                for (let periodo of periodi){
                                    if (periodo.userid===istruttore.userid){
                                        const inizioP=convertDate(periodo.workperioddatefrom)
                                        let fineP=convertDate(periodo.workperioddateto)
                                        fineP=fineP.plus({hours:23})
                                        if (inizioP<=dataLez && fineP>=dataLez){
                                            if (!(istruttore.userid in stipendiPersonale)){stipendiPersonale[istruttore.userid]={}}
                                            if (!("lezioni" in stipendiPersonale[istruttore.userid])){stipendiPersonale[istruttore.userid]["lezioni"]=0}
                                            let importoStip=0
                                            const durata=(convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000)
                                            if (periodo.workperiodfixedsalarycurrency===1){
                                                const numero = pacchetto.lessonnumstudents

                                                let paga= numero===1?durata*(periodo.workperiodhourlypayment):durata*(periodo.workperiodhourlypaymentgroups)
                                                if (istruttore.type===5 && pacchetto.lessontype==="Avanzata"){
                                                    let commissionLez=0
                                                    if (lezione.inventories.length>0)
                                                        commissionLez=periodo.workperiodcommissionratelessonmaterial/100
                                                    else
                                                        commissionLez=periodo.workperiodcommissionratelesson/100
                                                    paga=((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))*commissionLez*durata)/pacchetto.lessonpacket
                                                }
                                                stipendiPersonale[istruttore.userid]["lezioni"]+=paga
                                                importoStip=paga
                                                }
                                            else{
                                                importoStip=(((convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(60*60*1000))*(pacchetto.lessonnumstudents===1 ? periodo.workperiodhourlypayment : periodo.workperiodhourlypaymentgroups))/datiCambi[convertDate(lezione.lessondateend).toFormat("yyyyMMdd")]
                                                stipendiPersonale[istruttore.userid]["lezioni"]+=(((convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(60*60*1000))*(pacchetto.lessonnumstudents===1 ? periodo.workperiodhourlypayment : periodo.workperiodhourlypaymentgroups))/datiCambi[convertDate(lezione.lessondateend).toFormat("yyyyMMdd")]
                                            }
                                            const chiaveMese=dataLez.toFormat("yyyy-MM")
                                            const chiaveGiorno=dataLez.toISODate()
                                            const chiaveSettimana=`${dataLez.weekYear}-W${String(dataLez.weekNumber).padStart(2, "0")}`
                                            if (!("oretotali" in pacchetto) ) pacchetto["oretotali"]=0
                                            pacchetto["oretotali"]+=durata
                                            if (!(chiaveMese in stipendiPeriodi[1]))stipendiPeriodi[1][chiaveMese]=0
                                            stipendiPeriodi[1][chiaveMese]+=importoStip
                                            if (!(chiaveGiorno in stipendiPeriodi[3]))stipendiPeriodi[3][chiaveGiorno]=0
                                            stipendiPeriodi[3][chiaveGiorno]+=importoStip
                                            if (!(chiaveSettimana in stipendiPeriodi[2]))stipendiPeriodi[2][chiaveSettimana]=0
                                            stipendiPeriodi[2][chiaveSettimana]+=importoStip
                                            if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
                                           if (!("stipendi" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["stipendi"]={}
                                           if (!("lezioni" in periodiDettagliati[1][chiaveMese]["stipendi"]))periodiDettagliati[1][chiaveMese]["stipendi"]["lezioni"]=[]
                                            periodiDettagliati[1][chiaveMese]["stipendi"]["lezioni"]=[...periodiDettagliati[1][chiaveMese]["stipendi"]["lezioni"],[lezione,pacchetto,periodo]]
                                            if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
                                           if (!("stipendi" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["stipendi"]={}
                                           if (!("lezioni" in periodiDettagliati[3][chiaveGiorno]["stipendi"]))periodiDettagliati[3][chiaveGiorno]["stipendi"]["lezioni"]=[]
                                            periodiDettagliati[3][chiaveGiorno]["stipendi"]["lezioni"]=[...periodiDettagliati[3][chiaveGiorno]["stipendi"]["lezioni"],[lezione,pacchetto,periodo]]
                                            if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                                            if (!("stipendi" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["stipendi"]={}
                                            if (!("lezioni" in periodiDettagliati[2][chiaveSettimana]["stipendi"]))periodiDettagliati[2][chiaveSettimana]["stipendi"]["lezioni"]=[]
                                            periodiDettagliati[2][chiaveSettimana]["stipendi"]["lezioni"]=[...periodiDettagliati[2][chiaveSettimana]["stipendi"]["lezioni"],[lezione,pacchetto,periodo]]
                                            break
                                        }
                                    }
                                }

                            }
                        }
                        break
                    }
                }
            }
        }
        let speseDivise={}
        let speseGestione={}
        let speseStipendi=0
        let stipendiDivisi={}
        for (let utente of datiUtenti){
            if (utente.fixedsalary!==0){
                calcolaStipendioFisso(stipendiPersonale,utente,stipendiPagati,inizioFiltro,fineFiltro,periodi,datiCambi,escursioni,escursioniClienti,escursioniCosti,stipendiPeriodi,periodiDettagliati)
            }
        }
        for (let spesa of spese){
            const dataSpesa=convertDate(spesa.transactiondate)
            if (filtroL<=dataSpesa && finePF>=dataSpesa){
                if (spesa.registrytypecategory===1){
                    let importo=0
                    if (spesa.transactioncurrency===1){
                        importo=spesa.transactionvalue
                    }
                    else {
                        importo=spesa.transactionvalue/datiCambi[spesa.transactiondate]
                    }
                    speseTot+=importo
                    const chiaveMese=dataSpesa.toFormat("yyyy-MM")
                    const chiaveGiorno=dataSpesa.toISODate()
                    const chiaveSettimana=`${dataSpesa.weekYear}-W${String(dataSpesa.weekNumber).padStart(2, "0")}`
                    if (!(chiaveMese in spesePeriodi[1]))spesePeriodi[1][chiaveMese]=0
                    spesePeriodi[1][chiaveMese]+=importo
                    if (!(chiaveGiorno in spesePeriodi[3]))spesePeriodi[3][chiaveGiorno]=0
                    spesePeriodi[3][chiaveGiorno]+=importo
                    if (!(chiaveSettimana in spesePeriodi[2]))spesePeriodi[2][chiaveSettimana]=0
                    spesePeriodi[2][chiaveSettimana]+=importo
                    if (!(spesa.registrytypedescr in speseGestione))speseGestione[spesa.registrytypedescr]=0
                    speseGestione[spesa.registrytypedescr]+=importo
                    if (!(spesa.registrytypedescr in speseDivise))speseDivise[spesa.registrytypedescr]={}
                    if (!(spesa.registrysubtypedescr in speseDivise[spesa.registrytypedescr]))speseDivise[spesa.registrytypedescr][spesa.registrysubtypedescr]=0
                    speseDivise[spesa.registrytypedescr][spesa.registrysubtypedescr]+=importo
                    if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
               if (!("spese" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["spese"]=[]
                periodiDettagliati[1][chiaveMese]["spese"]=[...periodiDettagliati[1][chiaveMese]["spese"],spesa]
                if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
               if (!("spese" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["spese"]=[]
                periodiDettagliati[3][chiaveGiorno]["spese"]=[...periodiDettagliati[3][chiaveGiorno]["spese"],spesa]
                if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                if (!("spese" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["spese"]=[]
                periodiDettagliati[2][chiaveSettimana]["spese"]=[...periodiDettagliati[2][chiaveSettimana]["spese"],spesa]

                }
            }
        }
        let stipendi=0
        for (let persona in stipendiPersonale){
            for (let stipendio in stipendiPersonale[persona]){
                speseTot+=stipendiPersonale[persona][stipendio]
                stipendi+=stipendiPersonale[persona][stipendio]
                stipendiDivisi[`${stipendio} ${nome_id({id:parseInt(persona),utenti:datiUtenti})}`]=stipendiPersonale[persona][stipendio]
            }
        }
        let crediti=0
        for (let categoria in soldiFuori){
            if (categoria!=="escursioni"){
                for (let credito of soldiFuori[categoria]){
                    if (categoria==="lezioni"){
                        crediti+=(credito.lessoncost*(1-(credito.lessondiscount/100))-credito.lessonadvance)

                    }
                    else if (categoria==="noleggi"){
                        crediti+=(credito.rentalcost*(1-(credito.rentaldiscount/100))-credito.rentaladvance)
                    }
                    else if (categoria==="storage"){
                        crediti+=(credito.storagecost*(1-(credito.storagediscount/100))-credito.storageadvance)
                    }
                    else if (categoria==="maglie"){
                        const entrataMaglia=credito.accessorysoldcurrency===1?credito.accessorysoldprice:credito.accessorysoldprice/datiCambi[credito.accessorysolddate]
                        const anticipoMaglia=credito.accessorysoldcurrency===1?credito.accessorysoldadvance:credito.accessorysoldadvance/datiCambi[credito.accessorysolddate]
                        crediti+=entrataMaglia
                    }
                }
            }
            else {
                for (let id in soldiFuori[categoria]){
                    for (let persona of soldiFuori[categoria][id]){
                        crediti+=Math.abs(persona.excursioncustomeradvance - persona.excursioncustomerpaid)
                    }
                }
            }
        }
        const divGen = document.getElementById("divGen");
        divGen.innerHTML = "";
        const box1=creaKPI("Entrate totali",`${entrateTot.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,"black")
        divGen.appendChild(box1)
        const box2=creaKPI("Spese totali",`${speseTot.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,"red")
        divGen.appendChild(box2)
        const box3=creaKPI("Guadagno totale",`${(entrateTot-speseTot).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,(entrateTot-speseTot)>0?"green":"red")
        divGen.appendChild(box3)
        const box4=creaKPI("Crediti da riscuotere",`${(crediti).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,"yellow")
        divGen.appendChild(box4)
        const box5=creaKPI("Entrate con crediti",`${(crediti+entrateTot).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,"black")
        divGen.appendChild(box5)
        const box6=creaKPI("Guadagni con crediti",`${(crediti+entrateTot-speseTot).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,(crediti+entrateTot-speseTot)>0?"green":"red")
        divGen.appendChild(box6)
        let profittoPeriodi={}
        for (let tipo in entratePeriodi){
            if (!(tipo in profittoPeriodi))profittoPeriodi[tipo]={}
            const allKeys2 = new Set([
              ...Object.keys(entratePeriodi[tipo]),
              ...Object.keys(stipendiPeriodi[tipo]),
              ...Object.keys(spesePeriodi[tipo]),
            ]);
            for (let giorno of allKeys2){
                const entrateCiclo=entratePeriodi[tipo][giorno]?entratePeriodi[tipo][giorno]:0
                const speseCiclo=spesePeriodi[tipo][giorno]?spesePeriodi[tipo][giorno]:0
                const stipendiCiclo=stipendiPeriodi[tipo][giorno]?stipendiPeriodi[tipo][giorno]:0
                profittoPeriodi[tipo][giorno]=entrateCiclo-speseCiclo-stipendiCiclo
            }
        }
        const dataSourceEntrate = [
          { category: "Lezioni", valore: entrateLezioni },
          { category: "Noleggi", valore: entrateNoleggi },
          { category: "Storage", valore: entrateStorage },
          { category: "Escursioni", valore: entrateEscursioni },
          { category: "Merch", valore: entrateMaglie },
          { category: "Riparazioni", valore: entrateRiparazioni },

        ];
        let entrateDivise={"Lezioni":tipiLezioni,Noleggi:tipiNoleggi,Storage:tipiStorage,Escursioni:tipiEscursioni,Merch:tipiMaglie,Riparazioni:tipiRiparazioni}
        let entrateDiviseNumeri={"Lezioni":numeriLezioni,Noleggi:numeriNoleggi,Storage:numeriStorage,Escursioni:numeriEscursioni,Merch:numeriMaglie,Riparazioni:numeriRiparazioni}
        speseDivise["Stipendi"]=stipendiDivisi
        let dataSourceSpese=[{ category: "Stipendi", valore: stipendi },]
        for (let i in speseGestione){
            dataSourceSpese=[...dataSourceSpese,{ category: i, valore: speseGestione[i] }]
        }

        const entrateDiv = entratePeriodi[1];
        const stipendiDiv = stipendiPeriodi[1];
        const speseDiv = spesePeriodi[1];
        const profittoDiv = profittoPeriodi[1];
        const chartData = [];
        const allKeys = new Set([
          ...Object.keys(entrateDiv),
          ...Object.keys(stipendiDiv),
          ...Object.keys(speseDiv),
          ...Object.keys(profittoDiv),
        ]);
        for (const key of allKeys) {
          const dt = DateTime.fromFormat(key, "yyyy-MM", { zone: "utc" });
          const jsDate = dt.toJSDate()
          chartData.push({
            date: jsDate,
            entrate: entrateDiv[key] || 0,
            stipendi: stipendiDiv[key] || 0,
            spese: speseDiv[key] || 0,
            profitto: profittoDiv[key] || 0,
          });
        }

    const tabsIconAndText = [
      { id: 0, text: 'Divisione mensile'},
      { id: 1, text: 'Divisione settimanale'},
      { id: 2, text: 'Divisione giornaliera'},
    ];
    $("#chartPieEntrate").dxPieChart({
  dataSource: dataSourceEntrate,
  width:"50%",
  height:"100%",
  series: {

    argumentField: "category",
    valueField: "valore",
    label: {
      visible: true,
      connector: {
        visible: false,
      },
      customizeText: function (pointInfo) {
      return `${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`;
    }
    },
  },
  export: {
    enabled: true,
    formats: ['PNG', 'PDF', 'JPEG', 'SVG'],
    fileName: "grafico",
  },
  onPointClick:function(e){
  e.component.hideTooltip();
  apriPopupDettagliSpesa(e,entrateDivise,entrateDiviseNumeri)
  },
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>Categoria:</b> ${pointInfo.argument}<br>
            <b>Valore:</b> ${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} € <br>
            <b>Percentuale:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
  },
  legend: {
    horizontalAlignment: "center",
    verticalAlignment: "bottom",
  },
  title: "Suddivisione delle Entrate",
});
    $("#chartPieSpese").dxPieChart({
  dataSource: dataSourceSpese,
  width:"50%",
  height:"100%",
  series: {
    argumentField: "category",
    valueField: "valore",
    label: {
      visible: true,
      connector: {
        visible: false,
      },
      customizeText: function (pointInfo) {
      return `${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`;
    }
    },
  },
  export: {
    enabled: true,
    formats: ['PNG', 'PDF', 'JPEG', 'SVG'],
    fileName: "grafico",
  },
  onPointClick:function(e){
  e.component.hideTooltip();
  apriPopupDettagliSpesa(e,speseDivise)
  },
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>Categoria:</b> ${pointInfo.argument}<br>
            <b>Valore:</b> ${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} € <br>
            <b>Percentuale:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
  },
  legend: {
    horizontalAlignment: "center",
    verticalAlignment: "bottom",
  },
  title: "Suddivisione delle Spese",
});
$("#chartContainer").dxChart({
  dataSource: chartData,
  zoomAndPan: {
    argumentAxis: "both",
    valueAxis: "both"
  },
  argumentAxis: {
    argumentType: "datetime",},
  scrollBar: {
      visible: false,
    },
  series: [{
      argumentField: "date",
      valueField: "entrate",
      name: "Entrate",
      type: "spline",
    },
    {
      argumentField: "date",
      valueField: "spese",
      name: "Spese",
      type: "spline",
    },
    {
      argumentField: "date",
      valueField: "stipendi",
      name: "Stipendi",
      type: "spline",
    },
    {
      argumentField: "date",
      valueField: "profitto",
      name: "Profitto",
      type: "spline",
    }],
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
            html:
            "<b>Valore:</b> " + `${(pointInfo.value).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>Riferimento: </b>` +`${DateTime.fromJSDate(pointInfo.argument).setLocale("it").toFormat("LLLL yyyy")}`
        };
      },
  },
  title: "Andamento Mensile"
});
let formattedRows = chartData.map((row, index) => ({
        id: index,
        data: row.date,
        entrate: row.entrate,
        spese: row.spese,
        stipendi: row.stipendi,
        profitto: row.profitto,
      }));
    const allineamento="center"
    $("#datagridDettagli").dxDataGrid({
        dataSource:formattedRows,
        columns:[{dataField: "data", caption: "Data riferimento", alignment:allineamento,customizeText:function (e){;return DateTime.fromJSDate(e.value).setLocale("it").toFormat("LLLL yyyy")}},
            {dataField: "entrate", caption: "Entrate totali", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField: "spese", caption: "Spese totali", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField: "stipendi", caption: "Stipendi totali", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField: "profitto", caption: "Profitto totale", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
        {
            type: "buttons",
            width:"50px",
            buttons: [
              {
                hint: "Dettagli periodo",
                icon: "none",
                template: function (cellElement, cellInfo,) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faCircleInfo}
                      color="#03a9f4"
                      onClick={() =>{
                      handleClick(cellInfo,periodiDettagliati[1],datiUtenti,datiCambi)}}
                    />
                  );
                },
              }
            ],
          },
        ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },


    })
$('#divisioneDati').dxTabs({
      width: '100%',
      rtlEnabled: false,
      showNavButtons: false,
      dataSource: tabsIconAndText,
      orientation: "horizontal",
      stylingMode: "primary",
      iconPosition: "top",
      onSelectionChanged: function (e) {let  newIndex = e.component.option("selectedIndex");
      if (newIndex===-1)newIndex=0
      const entrateDiv = entratePeriodi[newIndex+1];
        const stipendiDiv = stipendiPeriodi[newIndex+1];
        const speseDiv = spesePeriodi[newIndex+1];
        const profittoDiv = profittoPeriodi[newIndex+1];
        let total=0
        for (let i in entrateDiv){
            total+=entrateDiv[i]
        }
        let chartData = [];
        const allKeys = new Set([
          ...Object.keys(entrateDiv),
          ...Object.keys(stipendiDiv),
          ...Object.keys(speseDiv),
          ...Object.keys(profittoDiv),
        ]);
        for (const key of allKeys) {
          let dt=null
          let jsDate=null
        if (newIndex===0)
          {dt = DateTime.fromFormat(key, "yyyy-MM", { zone: "utc" });

          jsDate = dt.toJSDate()}
        else if (newIndex===1)
        {const [year, week] = key.split("-W");
          dt = DateTime.fromObject(
          { weekYear: +year, weekNumber: +week },
          { zone: "utc" }  // oppure "none" in Luxon 3.x
        ).startOf("week")
        jsDate = dt.toJSDate()}

        else {
        dt = DateTime.fromFormat(key, "yyyy-MM-dd",{ zone: "utc" });
        jsDate = dt.toJSDate()
        }
          chartData.push({
            date: jsDate,
            entrate: entrateDiv[key] || 0,
            stipendi: stipendiDiv[key] || 0,
            spese: speseDiv[key] || 0,
            profitto: profittoDiv[key] || 0,
          });
        }
        $("#chartContainer").dxChart("instance").option("dataSource",chartData)
        $("#chartContainer").dxChart("instance").option("title",newIndex===0 ? "Andamento Mensile": newIndex===1 ? "Andamento Settimanale":"Andamento Giornaliero")
        let label={}
        let tooltip={}
         if (newIndex === 0) {
           label = {
            format: "monthAndYear"  // Mostra "dicembre 2024"
          };
           tooltip = {
            enabled: true,
            customizeTooltip: function (pointInfo) {
              return {
                html:
                  "<b>Valore:</b> " +
                  `${(pointInfo.value).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>Riferimento: </b>` +
                  `${DateTime.fromJSDate(pointInfo.argument).setLocale("it").toFormat("LLLL yyyy")}`
              };
            }
          };
        }
    else if (newIndex===1){
        label= {
          customizeText: function (arg) {
            const dt = DateTime.fromJSDate(arg.value, { zone: 'utc' });
            return"Settimana del " + dt.toFormat("dd/MM/yyyy") // Mostra "dicembre 2024"
          }
        }
        tooltip = {
            enabled: true,
            customizeTooltip: function (pointInfo) {
              return {
                html:
                  "<b>Valore:</b> " +
                  `${(pointInfo.value).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>Riferimento: </b>` +
                  `Settimana del ${DateTime.fromJSDate(pointInfo.argument,{ zone: 'utc' }).setLocale("it").toFormat("dd/MM/yyyy")}`
              };
            }
          };
    }
    else {
    label= {
      customizeText: function (arg) {
        const dt = DateTime.fromJSDate(arg.value, { zone: 'utc' });
        return  dt.toFormat("dd/MM/yyyy");
      }
    }
    tooltip = {
            enabled: true,
            customizeTooltip: function (pointInfo) {
              return {
                html:
                  "<b>Valore:</b> " +
                  `${(pointInfo.value).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>Riferimento: </b>` +
                  `${DateTime.fromJSDate(pointInfo.argument).setLocale("it").toFormat("dd/MM/yyyy")}`
              };
            }
          };
    }
    formattedRows = chartData.map((row, index) => ({
        data: row.date,
        entrate: row.entrate,
        spese: row.spese,
        stipendi: row.stipendi,
        profitto: row.profitto,
      }));
    formattedRows=formattedRows.sort((a, b) => a.data - b.data);
    const allineamento="center"
    let dataD=null
    $("#datagridDettagli").dxDataGrid("instance").option({
        dataSource:formattedRows,
        columns:[{dataField: "data", caption: "Data riferimento", alignment:allineamento,customizeText:function (e){
        if (newIndex===0)
        return DateTime.fromJSDate(e.value, { zone: 'utc' }).setLocale("it").toFormat("LLLL yyyy")
        else if (newIndex===1){
            dataD = DateTime.fromJSDate(e.value, { zone: 'utc' });
            return"Settimana del " + dataD.toFormat("dd/MM/yyyy")
        }
        else {
            return DateTime.fromJSDate(e.value,{ zone: 'utc' }).setLocale("it").toFormat("dd/MM/yyyy")
        }
        }},
            {dataField: "entrate", caption: "Entrate totali", alignment:allineamento,customizeText:function (e){if (e.value) {return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}else {return null}}},
            {dataField: "spese", caption: "Spese totali", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField: "stipendi", caption: "Stipendi totali", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField: "profitto", caption: "Profitto totale", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
        {
            type: "buttons",
            width:"50px",
            buttons: [
              {
                hint: "Dettagli periodo",
                icon: "none",
                template: function (cellElement, cellInfo,) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faCircleInfo}
                      color="#03a9f4"
                      onClick={() =>
                      handleClick(cellInfo,periodiDettagliati[newIndex+1],datiUtenti,datiCambi)}
                    />
                  );
                },
              }
            ],
          },
        ],})

    $("#chartContainer").dxChart("instance").option("tooltip",tooltip)
        $("#chartContainer").css({
  marginBottom: "30px",
});

      }
      })
      $('#divisioneDati').dxTabs("instance").option("selectedIndex", 0)
      let formattedRowsCreditiLezioni=[]
        let formattedRowsCreditiNoleggi=[]
        let formattedRowsCreditiStorage=[]
        let formattedRowsCreditiEscursioni=[]
        for (let tipo in soldiFuori){
            if (tipo==="lezioni"){
                for (let lezione of soldiFuori[tipo]){
                    formattedRowsCreditiLezioni.push({"nome":lezione.lessonstudentname,"pacchetto":`${lezione.lessonpacket}H`,"costo":`${(lezione.lessoncost*(1-(lezione.lessondiscount/100))).toLocaleString("it-IT", { maximumFractionDigits: 2 })}€`,"pagato":`${(lezione.lessonadvance).toLocaleString("it-IT", { maximumFractionDigits: 2 })}€`,"saldare":`${(lezione.lessoncost*(1-(lezione.lessondiscount/100))-lezione.lessonadvance).toLocaleString("it-IT", { maximumFractionDigits: 2 })}€`})
                }
            }
            else if (tipo==="noleggi"){
                for (let noleggio of soldiFuori[tipo]){
                    formattedRowsCreditiNoleggi.push({"nome":noleggio.rentalcustname,"tipo":noleggio.rentaltype,"costo":`${(noleggio.rentalcost*(1-(noleggio.rentaldiscount/100))).toLocaleString("it-IT", { maximumFractionDigits: 2 })}€`,"pagato":`${(noleggio.rentaladvance).toLocaleString("it-IT", { maximumFractionDigits: 2 })}€`,"saldare":`${(noleggio.rentalcost*(1-(noleggio.rentaldiscount/100))-noleggio.rentaladvance).toLocaleString("it-IT", { maximumFractionDigits: 2 })}€`})
                }
            }
            else if (tipo==="storage"){
                for (let storage of soldiFuori[tipo]){
                    formattedRowsCreditiStorage.push({"nome":storage.storagecustname,"tipo":storage.storagetype,"costo":`${(storage.storagecost*(1-(storage.storagediscount/100))).toLocaleString("it-IT", { maximumFractionDigits: 2 })}€`,"pagato":`${(storage.storageadvance).toLocaleString("it-IT", { maximumFractionDigits: 2 })}€`,"saldare":`${(storage.storagecost*(1-(storage.storagediscount/100))-storage.storageadvance).toLocaleString("it-IT", { maximumFractionDigits: 2 })}€`})
                }
            }
        }
        const containerLezioni = document.getElementById("LezioniFuoriContainer");
        containerLezioni.innerHTML = ""; // ← pulisce il contenuto precedente

        if (formattedRowsCreditiLezioni.length > 0) {
            const generaleLezioni = document.createElement("div");
            generaleLezioni.id = "contenitoreGeneraleLezioni";

            const commentoLezioni = document.createElement("div");
            commentoLezioni.innerText = "Crediti Lezioni";
            commentoLezioni.style.fontFamily = "Poppins";
            commentoLezioni.style.fontSize = "25px";
            commentoLezioni.style.fontWeight = "bold";
            commentoLezioni.style.margin="10px"
            const tabellaLezioni = document.createElement("div");
            tabellaLezioni.id = "datagridLezioniFuori";

            generaleLezioni.appendChild(commentoLezioni);
            generaleLezioni.appendChild(tabellaLezioni);
            containerLezioni.appendChild(generaleLezioni);
        }
        $("#datagridLezioniFuori").dxDataGrid({
        dataSource:formattedRowsCreditiLezioni,
        columns:[{dataField: "nome", caption: "Nome", alignment:allineamento},
            {dataField: "pacchetto", caption: "Pacchetto lezioni", alignment:allineamento,},
            {dataField: "costo", caption: "Costo pacchetto", alignment:allineamento},
            {dataField: "pagato", caption: "Pagato", alignment:allineamento,},
            {dataField: "saldare", caption: "Da saldare", alignment:allineamento},
            ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        })
        const containerNoleggi = document.getElementById("NoleggiFuoriContainer");
        containerNoleggi.innerHTML = ""; // ← pulisce il contenuto precedente

        if (formattedRowsCreditiNoleggi.length > 0) {
            const generaleNoleggi = document.createElement("div");
            generaleNoleggi.id = "contenitoreGeneraleNoleggi";

            const commentoNoleggi = document.createElement("div");
            commentoNoleggi.innerText = "Crediti Noleggi";
            commentoNoleggi.style.fontFamily = "Poppins";
            commentoNoleggi.style.fontSize = "25px";
            commentoNoleggi.style.fontWeight = "bold";
            commentoNoleggi.style.margin="10px"

            const tabellaNoleggi = document.createElement("div");
            tabellaNoleggi.id = "datagridNoleggiFuori";

            generaleNoleggi.appendChild(commentoNoleggi);
            generaleNoleggi.appendChild(tabellaNoleggi);
            containerNoleggi.appendChild(generaleNoleggi);
        }
        $("#datagridNoleggiFuori").dxDataGrid({
        dataSource:formattedRowsCreditiNoleggi,
        columns:[{dataField: "nome", caption: "Nome", alignment:allineamento},
            {dataField: "tipo", caption: "Tipo noleggio", alignment:allineamento,customizeText: function (e){return convertiIdNoleggio(e.value)}},
            {dataField: "costo", caption: "Costo pacchetto", alignment:allineamento},
            {dataField: "pagato", caption: "Pagato", alignment:allineamento,},
            {dataField: "saldare", caption: "Da saldare", alignment:allineamento},
            ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        })
        const container = document.getElementById("StorageFuoriContainer");
        container.innerHTML = ""; // ← pulisce il contenuto precedente

        if (formattedRowsCreditiStorage.length > 0) {
            const generaleStorage = document.createElement("div");
            generaleStorage.id = "contenitoreGeneraleStorage";

            const commentoStorage = document.createElement("div");
            commentoStorage.innerText = "Crediti storage";
            commentoStorage.style.fontFamily = "Poppins";
            commentoStorage.style.fontSize = "25px";
            commentoStorage.style.fontWeight = "bold";
            commentoStorage.style.margin="10px"

            const tabellaStorage = document.createElement("div");
            tabellaStorage.id = "datagridStorageFuori";

            generaleStorage.appendChild(commentoStorage);
            generaleStorage.appendChild(tabellaStorage);
            container.appendChild(generaleStorage);
        }
        $("#datagridStorageFuori").dxDataGrid({
        dataSource:formattedRowsCreditiStorage,
        columns:[{dataField: "nome", caption: "Nome", alignment:allineamento},
            {dataField: "tipo", caption: "Tipo Storage", alignment:allineamento,customizeText: function (e){return convertiTipoStorage(e.value)}},
            {dataField: "costo", caption: "Costo Storage", alignment:allineamento},
            {dataField: "pagato", caption: "Pagato", alignment:allineamento,},
            {dataField: "saldare", caption: "Da saldare", alignment:allineamento},
            ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        })
      $("#infoDettagli").dxPopup({
    width: "80%",
    height: '90%',
    visible: false,
    dragEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const popupHeight = e.component.option("height");
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll" style="height: 100%;"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    })}});








        }
    fetchDati()
    },[])
    return <div >
            <h2>Analisi economica</h2>
            <div id="infoDettagli"></div>
            <div id="dateboxperiodo"></div>
            <div id="divGen" className="kpi-grid"></div>
            <div id="divisioneDati"></div>
            <div id="chartContainer"></div>
            <div style={{display:"flex",width:"100%",height:"auto",alignItems: "center",justifyContent: "space-between",}}>
            <div id="chartPieEntrate"></div>
            <div id="chartPieSpese"></div>
            </div>
            <div id="datagridDettagli"></div>
            <div id="LezioniFuoriContainer"></div>
            <div id="NoleggiFuoriContainer"></div>
            <div id="StorageFuoriContainer"></div>
            <div id="loadingOverlay">
              <div className="spinner">
                <Lottie  style={{ width: "250px", height: "250px" }} animationData={animLoading} loop={true} />
              </div>
            </div>
          </div>

}

export default AnalisiEconomica;